/**
 * @generated SignedSource<<aa21e988b6499eb3027128dafc34ac74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgTeamListItem_team$data = {
  readonly color: string | null;
  readonly name: string;
  readonly store: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store">;
  };
  readonly topics: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"AHTeamIcon">;
  readonly " $fragmentType": "OrgTeamListItem_team";
};
export type OrgTeamListItem_team$key = {
  readonly " $data"?: OrgTeamListItem_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgTeamListItem_team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgTeamListItem_team",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AHTeamIcon"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreTopic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "2100bedf3a060cc5bf4c094571e9a5d2";

export default node;
